// pages/Gallery.js
//
// CONCEPTS DEMONSTRATED:
//   - useState for filter, visible count, AND lightbox state
//   - Lightbox: clicking an image sets selectedIndex in state,
//     which renders a fullscreen overlay with that image
//   - useEffect to listen for keyboard events (Escape, arrow keys)
//   - Preventing body scroll when lightbox is open

import React, { useEffect, useState, useCallback } from 'react';
import CtaBand from '../components/CtaBand';

// ─── PROJECT DATA ─────────────────────────────────────────────────────────────

const downpatrickPhotos = Array.from({ length: 22 }, (_, i) => ({
  tag:      'Luxury',
  title:    'Downpatrick Project',
  location: 'Co. Down',
  cat:      'luxury',
  image:    i === 0 ? '/images/downpatrick.jpg' : `/images/downpatrick${i}.jpg`,
}));

const otherProjects = [
  { tag: 'Traditional',  title: 'Hillsborough Manor',   location: 'Co. Down', cat: 'traditional',  bg: 'linear-gradient(160deg,#1e1e1e,#1a1a2e)' },
  { tag: 'Contemporary', title: 'Malone Road Residence', location: 'Belfast',  cat: 'contemporary', bg: 'linear-gradient(160deg,#1e2a1e,#1e1e1e)' },
  { tag: 'Modern',       title: 'Lisburn New Build',     location: 'Lisburn',  cat: 'modern',       bg: 'linear-gradient(160deg,#2a1e1e,#1e1e1e)' },
  { tag: 'Luxury',       title: 'Holywood, Co. Down',   location: 'Holywood', cat: 'luxury',       bg: 'linear-gradient(160deg,#1e2a1e,#1a1a2e)' },
  { tag: 'Compact', title: 'Hamill Street', location: 'Belfast', cat: 'compact', image: '/images/hamill-street1.jpg' },
  { tag: 'Compact', title: 'Hamill Street', location: 'Belfast', cat: 'compact', image: '/images/hamill-street2.jpg' },
  { tag: 'Compact', title: 'Hamill Street', location: 'Belfast', cat: 'compact', image: '/images/hamill-street3.jpg' },
  { tag: 'Compact', title: 'Hamill Street', location: 'Belfast', cat: 'compact', image: '/images/hamill-street4.jpg' },
  { tag: 'Compact', title: 'Hamill Street', location: 'Belfast', cat: 'compact', image: '/images/hamill-street5.jpg' },
  { tag: 'Compact', title: 'Hamill Street', location: 'Belfast', cat: 'compact', image: '/images/hamill-street6.jpg' },
  { tag: 'Compact', title: 'Hamill Street', location: 'Belfast', cat: 'compact', image: '/images/hamill-street7.jpg' },
  { tag: 'Compact', title: 'Hamill Street', location: 'Belfast', cat: 'compact', image: '/images/hamill-street8.jpg' },
  { tag: 'Compact', title: 'Finaghy', location: 'Belfast', cat: 'compact', image: '/images/finaghy-compact1.jpg' },
  { tag: 'Compact', title: 'Finaghy', location: 'Belfast', cat: 'compact', image: '/images/finaghy-compact2.jpg' },
  { tag: 'Compact', title: 'Finaghy', location: 'Belfast', cat: 'compact', image: '/images/finaghy-compact3.jpg' },
  { tag: 'Compact', title: 'Finaghy', location: 'Belfast', cat: 'compact', image: '/images/finaghy-compact4.jpg' },
  { tag: 'Modern', title: 'Lisburn Project', location: 'Lisburn', cat: 'modern', image: '/images/lisburn-project1.jpg' },
  { tag: 'Modern', title: 'Lisburn Project', location: 'Lisburn', cat: 'modern', image: '/images/lisburn-project2.jpg' },
  { tag: 'Modern', title: 'Lisburn Project', location: 'Lisburn', cat: 'modern', image: '/images/lisburn-project3.jpg' },
  { tag: 'Modern', title: 'Lisburn Project', location: 'Lisburn', cat: 'modern', image: '/images/lisburn-project4.jpg' },
  { tag: 'Contemporary', title: 'Darraghcross', location: 'Co. Down', cat: 'contemporary', image: '/images/Darraghcross1.jpg' },
  { tag: 'Contemporary', title: 'Darraghcross', location: 'Co. Down', cat: 'contemporary', image: '/images/Darraghcross2.jpg' },
  { tag: 'Contemporary', title: 'Darraghcross', location: 'Co. Down', cat: 'contemporary', image: '/images/Darraghcross3.jpg' },
  { tag: 'Contemporary', title: 'Darraghcross', location: 'Co. Down', cat: 'contemporary', image: '/images/Darraghcross4.jpg' },
  { tag: 'Contemporary', title: 'Darraghcross', location: 'Co. Down', cat: 'contemporary', image: '/images/Darraghcross5.jpg' },
  { tag: 'Contemporary', title: 'Darraghcross', location: 'Co. Down', cat: 'contemporary', image: '/images/Darraghcross6.jpg' },
  { tag: 'Contemporary', title: 'Darraghcross', location: 'Co. Down', cat: 'contemporary', image: '/images/Darraghcross7.jpg' },
  { tag: 'Contemporary', title: 'Darraghcross', location: 'Co. Down', cat: 'contemporary', image: '/images/Darraghcross8.jpg' },
  { tag: 'Contemporary', title: 'Darraghcross', location: 'Co. Down', cat: 'contemporary', image: '/images/Darraghcross9.jpg' },
  { tag: 'Contemporary', title: 'Darraghcross', location: 'Co. Down', cat: 'contemporary', image: '/images/Darraghcross10.jpg' },
  { tag: 'Traditional', title: 'Carryduff', location: 'Belfast', cat: 'traditional', image: '/images/carryduff1.jpg' },
  { tag: 'Traditional', title: 'Carryduff', location: 'Belfast', cat: 'traditional', image: '/images/carryduff2.jpg' },
  { tag: 'Compact', title: 'Stranmillis Apartment', location: 'Belfast', cat: 'compact', image: '/images/stranmillis1.jpg' },
  { tag: 'Compact', title: 'Stranmillis Apartment', location: 'Belfast', cat: 'compact', image: '/images/stranmillis2.jpg' },
  { tag: 'Compact', title: 'Stranmillis Apartment', location: 'Belfast', cat: 'compact', image: '/images/stranmillis3.jpg' },
  { tag: 'Compact', title: 'Stranmillis Apartment', location: 'Belfast', cat: 'compact', image: '/images/stranmillis4.jpg' },

];

const allProjects = [...downpatrickPhotos, ...otherProjects];
const filters     = ['all', 'modern', 'traditional', 'contemporary', 'luxury', 'compact'];
const INITIAL_SHOW = 6;
const LOAD_MORE_BY = 6;

// ─── COMPONENT ────────────────────────────────────────────────────────────────

export default function Gallery() {
  const [activeFilter,  setActiveFilter]  = useState('all');
  const [visibleCount,  setVisibleCount]  = useState(INITIAL_SHOW);

  // selectedIndex = the index (within the FILTERED list) of the open lightbox image.
  // null means lightbox is closed.
  const [selectedIndex, setSelectedIndex] = useState(null);

  useEffect(() => { window.scrollTo({ top: 0 }); }, []);

  // ── Derived values ──
   const filtered = activeFilter === 'all'
  ? [...allProjects].sort(() => Math.random() - 0.5)
  : allProjects.filter(p => p.cat === activeFilter);

  const visible = filtered.slice(0, visibleCount);
  const hasMore = visibleCount < filtered.length;

  // ── Filter handler — also resets visible count and closes lightbox ──
  const handleFilter = (f) => {
    setActiveFilter(f);
    setVisibleCount(INITIAL_SHOW);
    setSelectedIndex(null);
  };

  // ── Open lightbox ──
  const openLightbox = (index) => {
    setSelectedIndex(index);
    // Prevent the page from scrolling behind the lightbox
    document.body.style.overflow = 'hidden';
  };

  // ── Close lightbox ──
  const closeLightbox = useCallback(() => {
    setSelectedIndex(null);
    document.body.style.overflow = '';
  }, []);

  // ── Navigate within lightbox ──
  // We navigate within the FULL filtered list (not just the visible 6)
  // so the user can arrow through all photos
  const goNext = useCallback(() => {
    setSelectedIndex(prev => (prev + 1) % filtered.length);
  }, [filtered.length]);

  const goPrev = useCallback(() => {
    setSelectedIndex(prev => (prev - 1 + filtered.length) % filtered.length);
  }, [filtered.length]);

  // ── Keyboard controls ──
  // useEffect with event listener — runs once on mount, cleans up on unmount
  useEffect(() => {
    const handleKey = (e) => {
      if (selectedIndex === null) return; // lightbox not open, ignore
      if (e.key === 'Escape')     closeLightbox();
      if (e.key === 'ArrowRight') goNext();
      if (e.key === 'ArrowLeft')  goPrev();
    };
    window.addEventListener('keydown', handleKey);
    // Cleanup: remove listener when component unmounts or dependencies change
    return () => window.removeEventListener('keydown', handleKey);
  }, [selectedIndex, closeLightbox, goNext, goPrev]);

  // Current lightbox image
  const currentProject = selectedIndex !== null ? filtered[selectedIndex] : null;

  return (
    <div className="page-wrapper--inner">
      <div style={{ height: "60px" }} />
      <section className="section">
        <div className="container">
          <div className="label">Our Portfolio</div>
          <h2 className="heading-xl">
            Crafted<br />
            <span className="orange-italic">Excellence</span>
          </h2>
          <br />
          <p className="subtext" style={{ maxWidth: 600, marginBottom: '3rem' }}>
            Explore our collection of bespoke kitchens, each one a unique reflection
            of our clients' vision and our commitment to exceptional design.
          </p>

          {/* ── FILTER BUTTONS ── */}
          <div style={s.filterRow}>
            <span style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>⊿</span>
            {filters.map(f => (
              <button
                key={f}
                style={{
                  ...s.filterBtn,
                  background:  activeFilter === f ? 'var(--orange)' : 'transparent',
                  color:       activeFilter === f ? '#000' : 'var(--text-muted)',
                  borderColor: activeFilter === f ? 'var(--orange)' : 'var(--border)',
                }}
                onClick={() => handleFilter(f)}
              >
                {f.charAt(0).toUpperCase() + f.slice(1)}
              </button>
            ))}
          </div>

          {/* ── GALLERY GRID ── */}
          <style>{`
            .gal-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 1.5rem; }
            @media (max-width: 768px) { .gal-grid { grid-template-columns: 1fr; } }
          `}</style>
          <div className="gal-grid">
            {visible.map((project, i) => (
              <div
                key={i}
                style={s.item}
                onClick={() => openLightbox(i)}  // clicking opens lightbox at this index
                title="Click to enlarge"
              >
                {project.image ? (
                  <img
                    src={project.image}
                    alt={project.title}
                    style={s.gridImg}
                  />
                ) : (
                  <div style={{ ...s.placeholder, background: project.bg }}>
                    IMAGE COMING SOON
                  </div>
                )}

                {/* Hover hint */}
                <div style={s.hoverHint}>🔍 Click to enlarge</div>

                <div style={s.overlay}>
                  <div style={s.galTag}>{project.tag}</div>
                  <div style={s.galTitle}>{project.title}</div>
                  <div style={s.galLoc}>{project.location}</div>
                </div>
              </div>
            ))}
          </div>

          {/* ── LOAD MORE ── */}
          {hasMore && (
            <div style={{ textAlign: 'center', marginTop: '3rem' }}>
              <button
                className="btn-outline"
                onClick={() => setVisibleCount(prev => prev + LOAD_MORE_BY)}
              >
                Load More ({filtered.length - visibleCount} remaining)
              </button>
            </div>
          )}

          <p style={{ textAlign: 'center', color: 'var(--text-dim)', fontSize: '0.8rem', marginTop: '1.5rem' }}>
            Showing {Math.min(visibleCount, filtered.length)} of {filtered.length} projects
          </p>
        </div>
      </section>

      {/* ── LIGHTBOX ── */}
      {/* Only renders when selectedIndex is not null */}
      {currentProject && (
        <div style={s.lightboxOverlay} onClick={closeLightbox}>

          {/* Stop clicks on the inner content from closing the lightbox */}
          <div style={s.lightboxInner} onClick={e => e.stopPropagation()}>

            {/* Close button */}
            <button style={s.closeBtn} onClick={closeLightbox}>✕</button>

            {/* Counter e.g. "3 / 22" */}
            <div style={s.counter}>
              {selectedIndex + 1} / {filtered.length}
            </div>

            {/* Previous button */}
            <button style={{ ...s.navBtn, left: '1rem' }} onClick={goPrev}>‹</button>

            {/* The full-size image */}
            {currentProject.image ? (
              <img
                src={currentProject.image}
                alt={currentProject.title}
                style={s.lightboxImg}
              />
            ) : (
              <div style={{ ...s.placeholder, width: '100%', height: '70vh', background: currentProject.bg }} />
            )}

            {/* Next button */}
            <button style={{ ...s.navBtn, right: '1rem' }} onClick={goNext}>›</button>

            {/* Caption */}
            <div style={s.caption}>
              <span style={s.captionTag}>{currentProject.tag}</span>
              <span style={s.captionTitle}>{currentProject.title}</span>
              <span style={s.captionLoc}>{currentProject.location}</span>
            </div>
          </div>

          {/* Keyboard hint */}
          <div style={s.keyHint}>
            ← → arrow keys to navigate &nbsp;·&nbsp; Esc to close
          </div>
        </div>
      )}

      <CtaBand
        title="Inspired by What You See?"
        text="Let's create something extraordinary for your home."
        buttons={[{ label: 'Book a Consultation', to: '/contact' }]}
      />
    </div>
  );
}

// ─── STYLES ───────────────────────────────────────────────────────────────────
const s = {
  // Grid
  filterRow: { display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '3rem', flexWrap: 'wrap' },
  filterBtn: { fontFamily: "'Jost', sans-serif", fontSize: '0.72rem', fontWeight: 500, letterSpacing: '0.12em', textTransform: 'uppercase', padding: '0.5rem 1.2rem', border: '1px solid', cursor: 'pointer', transition: 'all 0.2s' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '1.5rem' },
  item: { position: 'relative', overflow: 'hidden', cursor: 'pointer' },
  gridImg: { width: '100%', aspectRatio: '3/4', objectFit: 'cover', display: 'block', transition: 'transform 0.4s' },
  placeholder: { aspectRatio: '3/4', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-dim)', fontSize: '0.75rem' },
  hoverHint: { position: 'absolute', top: '1rem', right: '1rem', background: 'rgba(0,0,0,0.6)', color: '#fff', fontSize: '0.72rem', padding: '0.3rem 0.6rem', opacity: 0, transition: 'opacity 0.2s', pointerEvents: 'none' },
  overlay: { position: 'absolute', bottom: 0, left: 0, right: 0, background: 'linear-gradient(transparent,rgba(0,0,0,0.85))', padding: '2rem 1.5rem 1.5rem' },
  galTag: { fontSize: '0.65rem', fontWeight: 500, letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--orange)', marginBottom: '0.3rem' },
  galTitle: { fontFamily: "'Cormorant Garamond', serif", fontSize: '1.2rem', fontWeight: 500 },
  galLoc: { fontSize: '0.78rem', color: 'var(--text-muted)' },

  // Lightbox overlay — covers the entire screen
  lightboxOverlay: {
    position: 'fixed', inset: 0, zIndex: 2000,
    background: 'rgba(0,0,0,0.95)',
    display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'center',
    padding: '2rem',
  },
  lightboxInner: {
    position: 'relative',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    width: '100%', maxWidth: '1200px',
  },
  lightboxImg: {
    maxWidth: '100%', maxHeight: '80vh',
    objectFit: 'contain',
    display: 'block',
    boxShadow: '0 25px 80px rgba(0,0,0,0.8)',
  },

  // Close button — top right
  closeBtn: {
    position: 'absolute', top: '-3rem', right: 0,
    background: 'none', border: '1px solid rgba(255,255,255,0.3)',
    color: '#fff', fontSize: '1.2rem', width: 40, height: 40,
    cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
    borderRadius: '50%', transition: 'all 0.2s',
  },

  // Counter "3 / 22"
  counter: {
    position: 'absolute', top: '-3rem', left: 0,
    color: 'var(--text-muted)', fontSize: '0.82rem', letterSpacing: '0.1em',
  },

  // Prev / Next arrow buttons
  navBtn: {
    position: 'absolute',
    background: 'rgba(232,130,26,0.15)',
    border: '1px solid rgba(232,130,26,0.4)',
    color: 'var(--orange)', fontSize: '2.5rem', lineHeight: 1,
    width: 56, height: 56, cursor: 'pointer',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    transition: 'all 0.2s', zIndex: 1,
  },

  // Caption below image
  caption: {
    position: 'absolute', bottom: '-3.5rem', left: 0, right: 0,
    display: 'flex', alignItems: 'center', gap: '1rem',
    justifyContent: 'center',
  },
  captionTag: { fontSize: '0.65rem', fontWeight: 600, letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--orange)' },
  captionTitle: { fontFamily: "'Cormorant Garamond', serif", fontSize: '1.1rem', color: '#fff' },
  captionLoc: { fontSize: '0.78rem', color: 'var(--text-muted)' },

  // Keyboard hint at very bottom
  keyHint: {
    position: 'absolute', bottom: '1.5rem',
    color: 'var(--text-dim)', fontSize: '0.75rem', letterSpacing: '0.05em',
  },
};
